import {
    makeStyles
} from '@material-ui/core';


export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  link: {
    fontSize: 16,
    textTransform: 'capitalize',
    fontFamily: theme.typography.h5.fontFamily,
  },
  title: {
    flexGrow: 1,
  },
}));